import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./auth-users.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

export default class AuthUsersApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.authUsers;
    }

    /**
     * Get AuthUsers
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

    /**
     * Search AuthUsers by query
     * @param {string} query - Search pattern
     * @param {Object} metadata - Request settings, like: limit, ofset etc.
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.config.searchUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/auth-users/auth-users.service.js